// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModuleItem-module__font-s-10____VFq3 {
  font-size: 10px !important;
}

.ModuleItem-module__font-s-12___rIfMR {
  font-size: 12px !important;
}

.ModuleItem-module__font-s-13___OiZe4 {
  font-size: 13px !important;
}

.ModuleItem-module__font-s-14___cE5l3 {
  font-size: 14px !important;
}

.ModuleItem-module__font-s-15___rLn0I {
  font-size: 15px !important;
}

.ModuleItem-module__font-s-16___R2agh {
  font-size: 16px !important;
}

.ModuleItem-module__font-s-18___hUTnl {
  font-size: 18px !important;
}

.ModuleItem-module__font-s-20___zLwS9 {
  font-size: 20px !important;
}

.ModuleItem-module__font-s-22___S9djz {
  font-size: 22px !important;
}

.ModuleItem-module__font-s-28___zTnzx {
  font-size: 28px !important;
}

.ModuleItem-module__font-w-400___NpFcu {
  font-weight: 400 !important;
}

.ModuleItem-module__font-w-500___Wz_aW {
  font-weight: 500 !important;
}

.ModuleItem-module__font-w-600___fWJyF {
  font-weight: 600 !important;
}

.ModuleItem-module__font-w-700___Ks4fd {
  font-weight: 700 !important;
}

.ModuleItem-module__p-5___NDY8B {
  padding: 5px !important;
}

.ModuleItem-module__p-12___m6M_H {
  padding: 12px !important;
}

.ModuleItem-module__p-16___l8ALh {
  padding: 16px !important;
}

.ModuleItem-module__p-30___JTaCg {
  padding: 30px !important;
}

.ModuleItem-module__p-b-0___RiQ9v {
  padding-bottom: 0 !important;
}

.ModuleItem-module__p-b-5___gj52E {
  padding-bottom: 5px !important;
}

.ModuleItem-module__p-b-10___6_rgq {
  padding-bottom: 10px !important;
}

.ModuleItem-module__p-b-12___xlshy {
  padding-bottom: 12px !important;
}

.ModuleItem-module__p-b-16___DH_9C {
  padding-bottom: 16px !important;
}

.ModuleItem-module__p-b-18____ECEC {
  padding-bottom: 18px !important;
}

.ModuleItem-module__p-b-20___PYyeM {
  padding-bottom: 20px !important;
}

.ModuleItem-module__p-b-25___mGiWJ {
  padding-bottom: 25px !important;
}

.ModuleItem-module__p-b-30___fBbXW {
  padding-bottom: 30px !important;
}

.ModuleItem-module__p-b-50___jwwLE {
  padding-bottom: 50px !important;
}

.ModuleItem-module__p-t-0___EBbaj {
  padding-top: 0 !important;
}

.ModuleItem-module__p-t-12___Sl178 {
  padding-top: 12px !important;
}

.ModuleItem-module__p-t-16___wP_kp {
  padding-top: 16px !important;
}

.ModuleItem-module__p-t-18___nJDGw {
  padding-top: 18px !important;
}

.ModuleItem-module__p-t-20___U67dw {
  padding-top: 20px !important;
}

.ModuleItem-module__p-t-30___a2E_2 {
  padding-top: 30px !important;
}

.ModuleItem-module__p-t-40___HPeDd {
  padding-top: 40px !important;
}

.ModuleItem-module__p-t-50___bpcjf {
  padding-top: 50px !important;
}

.ModuleItem-module__p-l-20___Gge6Z {
  padding-left: 20px !important;
}

.ModuleItem-module__p-l-30___OZfKz {
  padding-left: 30px !important;
}

.ModuleItem-module__p-l-40___IJ2_V {
  padding-left: 40px !important;
}

.ModuleItem-module__p-r-16___NOHQF {
  padding-right: 16px !important;
}

.ModuleItem-module__p-r-20___tSb7v {
  padding-right: 20px !important;
}

.ModuleItem-module__p-r-30___LdoJI {
  padding-right: 30px !important;
}

.ModuleItem-module__p-r-50___HRXxN {
  padding-right: 50px !important;
}

.ModuleItem-module__p-r-60___xq3h9 {
  padding-right: 60px !important;
}

.ModuleItem-module__m-b-1___O61gW {
  margin-bottom: 1px !important;
}

.ModuleItem-module__m-b-2___pcYeo {
  margin-bottom: 2px !important;
}

.ModuleItem-module__m-b-6___lFphN {
  margin-bottom: 6px !important;
}

.ModuleItem-module__m-b-8___DpEQu {
  margin-bottom: 8px !important;
}

.ModuleItem-module__m-b-10___wAWze {
  margin-bottom: 10px !important;
}

.ModuleItem-module__m-b-14___MhJWt {
  margin-bottom: 14px !important;
}

.ModuleItem-module__m-b-16___iepWN {
  margin-bottom: 16px !important;
}

.ModuleItem-module__m-b-20___yh1HL {
  margin-bottom: 20px !important;
}

.ModuleItem-module__m-b-22___TbReB {
  margin-bottom: 22px !important;
}

.ModuleItem-module__m-b-24____KKcD {
  margin-bottom: 24px !important;
}

.ModuleItem-module__m-b-30___e8A0V {
  margin-bottom: 30px !important;
}

.ModuleItem-module__m-b-32___Z4HAl {
  margin-bottom: 32px !important;
}

.ModuleItem-module__m-b-40___eSmsN {
  margin-bottom: 40px !important;
}

.ModuleItem-module__m-t-2___DnymA {
  margin-top: 2px !important;
}

.ModuleItem-module__m-t-3___EjPXC {
  margin-top: 3px !important;
}

.ModuleItem-module__m-t-4___Y3ex9 {
  margin-top: 4px !important;
}

.ModuleItem-module__m-t-5___bRqYa {
  margin-top: 5px !important;
}

.ModuleItem-module__m-t-8___t_djo {
  margin-top: 8px !important;
}

.ModuleItem-module__m-t-10___YCfVB {
  margin-top: 10px !important;
}

.ModuleItem-module__m-t-15___kqbw3 {
  margin-top: 15px !important;
}

.ModuleItem-module__m-t-16___GfaFo {
  margin-top: 16px !important;
}

.ModuleItem-module__m-t-20___DlHyL {
  margin-top: 20px !important;
}

.ModuleItem-module__m-t-22___epwxK {
  margin-top: 22px !important;
}

.ModuleItem-module__m-t-30___HGleF {
  margin-top: 30px !important;
}

.ModuleItem-module__m-t-32___BjAT2 {
  margin-top: 32px !important;
}

.ModuleItem-module__m-l-auto___VJ_K4 {
  margin-left: auto !important;
}

.ModuleItem-module__m-l-4___YoJJ4 {
  margin-left: 4px !important;
}

.ModuleItem-module__m-l-5___EOIyM {
  margin-left: 5px !important;
}

.ModuleItem-module__m-l-6___V5SQv {
  margin-left: 6px !important;
}

.ModuleItem-module__m-l-8___oiAtN {
  margin-left: 8px !important;
}

.ModuleItem-module__m-l-10___wakKt {
  margin-left: 10px !important;
}

.ModuleItem-module__m-l-16___unWS9 {
  margin-left: 16px !important;
}

.ModuleItem-module__m-l-20___rOyrH {
  margin-left: 20px !important;
}

.ModuleItem-module__m-l-24___wb5kH {
  margin-left: 24px !important;
}

.ModuleItem-module__m-l-30___cD7Hm {
  margin-left: 30px !important;
}

.ModuleItem-module__m-l-35___KSTch {
  margin-left: 35px !important;
}

.ModuleItem-module__m-l-40___b5bwX {
  margin-left: 40px !important;
}

.ModuleItem-module__m-r-8___NEef5 {
  margin-right: 8px !important;
}

.ModuleItem-module__m-r-10___Lxpa5 {
  margin-right: 10px !important;
}

.ModuleItem-module__m-r-16___jNp5b {
  margin-right: 16px !important;
}

.ModuleItem-module__m-r-20___NVufS {
  margin-right: 20px !important;
}

.ModuleItem-module__m-r-24___Bd2L5 {
  margin-right: 24px !important;
}

.ModuleItem-module__m-r-30___QvpWM {
  margin-right: 30px !important;
}

.ModuleItem-module__m-r-40___LXV3o {
  margin-right: 40px !important;
}

.ModuleItem-module__border-r-3___Vjjp9 {
  border-radius: 3px !important;
}

.ModuleItem-module__border-r-4___tgSQY {
  border-radius: 4px !important;
}

.ModuleItem-module__border-r-6___s75Ii {
  border-radius: 6px !important;
}

.ModuleItem-module__border-r-10___EQ5Eb {
  border-radius: 10px !important;
}

.ModuleItem-module__border-r-12___PMIhH {
  border-radius: 12px !important;
}

.ModuleItem-module__border-r-16___ICMGw {
  border-radius: 16px !important;
}

.ModuleItem-module__border-r-50___aLNtz {
  border-radius: 50% !important;
}

.ModuleItem-module__primary-border___NUddq {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ModuleItem-module__primary-border-b___XT0c_ {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ModuleItem-module__primary-border-t___PdmnW {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ModuleItem-module__primary-border-l___TkcKI {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ModuleItem-module__primary-border-r___OB4Uh {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ModuleItem-module__secondary-border____ruQN {
  border: 1px solid #637768;
}

.ModuleItem-module__secondary-border-b___NwJYs {
  border-bottom: 1px solid #637768;
}

.ModuleItem-module__secondary-border-t___l53_5 {
  border-top: 1px solid #637768;
}

.ModuleItem-module__secondary-border-l___yEqmg {
  border-left: 1px solid #637768;
}

.ModuleItem-module__secondary-border-r___ysxY1 {
  border-right: 1px solid #637768;
}

.ModuleItem-module__gap-0___btQbq {
  gap: 0 !important;
}

.ModuleItem-module__gap-2___QfYlI {
  gap: 2px !important;
}

.ModuleItem-module__gap-4___X3IKB {
  gap: 4px !important;
}

.ModuleItem-module__gap-5___l6Qvk {
  gap: 5px !important;
}

.ModuleItem-module__gap-6___kH3il {
  gap: 6px !important;
}

.ModuleItem-module__gap-8___BThbw {
  gap: 8px !important;
}

.ModuleItem-module__gap-10___VmnRY {
  gap: 10px !important;
}

.ModuleItem-module__gap-12___SCaCk {
  gap: 12px !important;
}

.ModuleItem-module__gap-14___wkxvQ {
  gap: 14px !important;
}

.ModuleItem-module__gap-16___F4xkG {
  gap: 16px !important;
}

.ModuleItem-module__gap-18___pbNVq {
  gap: 18px !important;
}

.ModuleItem-module__gap-20____6wCp {
  gap: 20px !important;
}

.ModuleItem-module__gap-24___Ja7ET {
  gap: 24px !important;
}

.ModuleItem-module__gap-26___jSgDZ {
  gap: 26px !important;
}

.ModuleItem-module__gap-30___RGWNJ {
  gap: 30px !important;
}

.ModuleItem-module__gap-32___mUmbF {
  gap: 32px !important;
}

.ModuleItem-module__gap-40___ihPA1 {
  gap: 40px !important;
}

.ModuleItem-module__gap-50___NY798 {
  gap: 50px !important;
}

.ModuleItem-module__flex-1___D0Dpr {
  flex: 1;
}

.ModuleItem-module__flex-none___J106B {
  flex: none !important;
}

.ModuleItem-module__flex-column___kMDBW {
  display: flex;
  flex-direction: column !important;
}

.ModuleItem-module__flex-row___aLdez {
  display: flex;
  flex-direction: row !important;
}

.ModuleItem-module__vertically-centered___CjbXc {
  display: flex;
  align-items: center !important;
}

.ModuleItem-module__horizontally-centered___bV3Gq {
  display: flex;
  justify-content: center !important;
}

.ModuleItem-module__horizontally-end___K3atM {
  display: flex;
  justify-content: end !important;
}

.ModuleItem-module__vertically-start___vkIVl {
  display: flex;
  align-items: start !important;
}

.ModuleItem-module__space-between___JOk1k {
  display: flex;
  justify-content: space-between !important;
}

.ModuleItem-module__flex-wrap___glaE8 {
  flex-wrap: wrap !important;
}

.ModuleItem-module__height-100___eti2I {
  height: 100%;
}

.ModuleItem-module__width-50___xUqYS {
  width: 50% !important;
}

.ModuleItem-module__width-100___L8dDP {
  width: 100%;
}

.ModuleItem-module__cursor-pointer___BbeQa {
  cursor: pointer;
}

.ModuleItem-module__cursor-not-allowed___BJQnW {
  cursor: not-allowed !important;
}

.ModuleItem-module__absolute-centered___d0GAR {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ModuleItem-module__absolute___V4dJW {
  position: absolute;
}

.ModuleItem-module__relative___grn_l {
  position: relative;
}

.ModuleItem-module__fixed___QPVQY {
  position: fixed;
}

.ModuleItem-module__visible___zqGPE {
  opacity: 1;
}

.ModuleItem-module__invisible___NOarl {
  opacity: 0;
}

.ModuleItem-module__col-90___SvAY9 {
  width: 90% !important;
}

.ModuleItem-module__col-auto___qtV6A {
  width: auto !important;
}

.ModuleItem-module__medical-tabs___QK6Xt {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ModuleItem-module__medical-table-new___Txo8F {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ModuleItem-module__medical-table-new___Txo8F:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ModuleItem-module__medical-table-new___Txo8F::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ModuleItem-module__medical-table-new___Txo8F::-webkit-scrollbar-track {
  display: none;
}
.ModuleItem-module__medical-table-new___Txo8F.ModuleItem-module__no-pagination___uGSw1 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ModuleItem-module__medical-table-new___Txo8F.ModuleItem-module__no-pagination___uGSw1:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ModuleItem-module__medical-table-new___Txo8F.ModuleItem-module__no-pagination___uGSw1::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ModuleItem-module__medical-table-new___Txo8F.ModuleItem-module__no-pagination___uGSw1::-webkit-scrollbar-track {
  display: none;
}

.ModuleItem-module__medical-table-empty___MGXCS {
  padding: 14px 40px !important;
}

.ModuleItem-module__icon-btn___ijeDN {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ModuleItem-module__search-icon___ZFM8j {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ModuleItem-module__disable-select___Jv3Nq {
  user-select: none;
}

.ModuleItem-module__break-word___R45EX {
  word-break: break-word;
}

.ModuleItem-module__popup-clear-btn___GHIvo {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ModuleItem-module__scroll-m-b-20___CBvER {
  scroll-margin-bottom: 20px;
}

.ModuleItem-module__checkboxWrapper___zElj6 {
  padding: 10px 30px;
}
.ModuleItem-module__checkboxWrapper___zElj6.ModuleItem-module__selected___AdZsM {
  background-color: #fbf7f2;
}
.ModuleItem-module__checkboxWrapper___zElj6:last-child {
  margin-bottom: 0;
}
.ModuleItem-module__checkboxWrapper___zElj6 .ModuleItem-module__instructions___g_bFp {
  margin: 10px 0 0 35px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/components/SectionAside/items/ModuleItem/ModuleItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;AA8pBF;AA5pBE;EACE,yBAAA;AA8pBJ;AA3pBE;EACE,gBAAA;AA6pBJ;AA1pBE;EACE,qBAAA;AA4pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.checkboxWrapper {\n  padding: 10px 30px;\n\n  &.selected {\n    background-color: get-color(orangeNew, light);\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  .instructions {\n    margin: 10px 0 0 35px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ModuleItem-module__font-s-10____VFq3`,
	"fontS12": `ModuleItem-module__font-s-12___rIfMR`,
	"fontS13": `ModuleItem-module__font-s-13___OiZe4`,
	"fontS14": `ModuleItem-module__font-s-14___cE5l3`,
	"fontS15": `ModuleItem-module__font-s-15___rLn0I`,
	"fontS16": `ModuleItem-module__font-s-16___R2agh`,
	"fontS18": `ModuleItem-module__font-s-18___hUTnl`,
	"fontS20": `ModuleItem-module__font-s-20___zLwS9`,
	"fontS22": `ModuleItem-module__font-s-22___S9djz`,
	"fontS28": `ModuleItem-module__font-s-28___zTnzx`,
	"fontW400": `ModuleItem-module__font-w-400___NpFcu`,
	"fontW500": `ModuleItem-module__font-w-500___Wz_aW`,
	"fontW600": `ModuleItem-module__font-w-600___fWJyF`,
	"fontW700": `ModuleItem-module__font-w-700___Ks4fd`,
	"p5": `ModuleItem-module__p-5___NDY8B`,
	"p12": `ModuleItem-module__p-12___m6M_H`,
	"p16": `ModuleItem-module__p-16___l8ALh`,
	"p30": `ModuleItem-module__p-30___JTaCg`,
	"pB0": `ModuleItem-module__p-b-0___RiQ9v`,
	"pB5": `ModuleItem-module__p-b-5___gj52E`,
	"pB10": `ModuleItem-module__p-b-10___6_rgq`,
	"pB12": `ModuleItem-module__p-b-12___xlshy`,
	"pB16": `ModuleItem-module__p-b-16___DH_9C`,
	"pB18": `ModuleItem-module__p-b-18____ECEC`,
	"pB20": `ModuleItem-module__p-b-20___PYyeM`,
	"pB25": `ModuleItem-module__p-b-25___mGiWJ`,
	"pB30": `ModuleItem-module__p-b-30___fBbXW`,
	"pB50": `ModuleItem-module__p-b-50___jwwLE`,
	"pT0": `ModuleItem-module__p-t-0___EBbaj`,
	"pT12": `ModuleItem-module__p-t-12___Sl178`,
	"pT16": `ModuleItem-module__p-t-16___wP_kp`,
	"pT18": `ModuleItem-module__p-t-18___nJDGw`,
	"pT20": `ModuleItem-module__p-t-20___U67dw`,
	"pT30": `ModuleItem-module__p-t-30___a2E_2`,
	"pT40": `ModuleItem-module__p-t-40___HPeDd`,
	"pT50": `ModuleItem-module__p-t-50___bpcjf`,
	"pL20": `ModuleItem-module__p-l-20___Gge6Z`,
	"pL30": `ModuleItem-module__p-l-30___OZfKz`,
	"pL40": `ModuleItem-module__p-l-40___IJ2_V`,
	"pR16": `ModuleItem-module__p-r-16___NOHQF`,
	"pR20": `ModuleItem-module__p-r-20___tSb7v`,
	"pR30": `ModuleItem-module__p-r-30___LdoJI`,
	"pR50": `ModuleItem-module__p-r-50___HRXxN`,
	"pR60": `ModuleItem-module__p-r-60___xq3h9`,
	"mB1": `ModuleItem-module__m-b-1___O61gW`,
	"mB2": `ModuleItem-module__m-b-2___pcYeo`,
	"mB6": `ModuleItem-module__m-b-6___lFphN`,
	"mB8": `ModuleItem-module__m-b-8___DpEQu`,
	"mB10": `ModuleItem-module__m-b-10___wAWze`,
	"mB14": `ModuleItem-module__m-b-14___MhJWt`,
	"mB16": `ModuleItem-module__m-b-16___iepWN`,
	"mB20": `ModuleItem-module__m-b-20___yh1HL`,
	"mB22": `ModuleItem-module__m-b-22___TbReB`,
	"mB24": `ModuleItem-module__m-b-24____KKcD`,
	"mB30": `ModuleItem-module__m-b-30___e8A0V`,
	"mB32": `ModuleItem-module__m-b-32___Z4HAl`,
	"mB40": `ModuleItem-module__m-b-40___eSmsN`,
	"mT2": `ModuleItem-module__m-t-2___DnymA`,
	"mT3": `ModuleItem-module__m-t-3___EjPXC`,
	"mT4": `ModuleItem-module__m-t-4___Y3ex9`,
	"mT5": `ModuleItem-module__m-t-5___bRqYa`,
	"mT8": `ModuleItem-module__m-t-8___t_djo`,
	"mT10": `ModuleItem-module__m-t-10___YCfVB`,
	"mT15": `ModuleItem-module__m-t-15___kqbw3`,
	"mT16": `ModuleItem-module__m-t-16___GfaFo`,
	"mT20": `ModuleItem-module__m-t-20___DlHyL`,
	"mT22": `ModuleItem-module__m-t-22___epwxK`,
	"mT30": `ModuleItem-module__m-t-30___HGleF`,
	"mT32": `ModuleItem-module__m-t-32___BjAT2`,
	"mLAuto": `ModuleItem-module__m-l-auto___VJ_K4`,
	"mL4": `ModuleItem-module__m-l-4___YoJJ4`,
	"mL5": `ModuleItem-module__m-l-5___EOIyM`,
	"mL6": `ModuleItem-module__m-l-6___V5SQv`,
	"mL8": `ModuleItem-module__m-l-8___oiAtN`,
	"mL10": `ModuleItem-module__m-l-10___wakKt`,
	"mL16": `ModuleItem-module__m-l-16___unWS9`,
	"mL20": `ModuleItem-module__m-l-20___rOyrH`,
	"mL24": `ModuleItem-module__m-l-24___wb5kH`,
	"mL30": `ModuleItem-module__m-l-30___cD7Hm`,
	"mL35": `ModuleItem-module__m-l-35___KSTch`,
	"mL40": `ModuleItem-module__m-l-40___b5bwX`,
	"mR8": `ModuleItem-module__m-r-8___NEef5`,
	"mR10": `ModuleItem-module__m-r-10___Lxpa5`,
	"mR16": `ModuleItem-module__m-r-16___jNp5b`,
	"mR20": `ModuleItem-module__m-r-20___NVufS`,
	"mR24": `ModuleItem-module__m-r-24___Bd2L5`,
	"mR30": `ModuleItem-module__m-r-30___QvpWM`,
	"mR40": `ModuleItem-module__m-r-40___LXV3o`,
	"borderR3": `ModuleItem-module__border-r-3___Vjjp9`,
	"borderR4": `ModuleItem-module__border-r-4___tgSQY`,
	"borderR6": `ModuleItem-module__border-r-6___s75Ii`,
	"borderR10": `ModuleItem-module__border-r-10___EQ5Eb`,
	"borderR12": `ModuleItem-module__border-r-12___PMIhH`,
	"borderR16": `ModuleItem-module__border-r-16___ICMGw`,
	"borderR50": `ModuleItem-module__border-r-50___aLNtz`,
	"primaryBorder": `ModuleItem-module__primary-border___NUddq`,
	"primaryBorderB": `ModuleItem-module__primary-border-b___XT0c_`,
	"primaryBorderT": `ModuleItem-module__primary-border-t___PdmnW`,
	"primaryBorderL": `ModuleItem-module__primary-border-l___TkcKI`,
	"primaryBorderR": `ModuleItem-module__primary-border-r___OB4Uh`,
	"secondaryBorder": `ModuleItem-module__secondary-border____ruQN`,
	"secondaryBorderB": `ModuleItem-module__secondary-border-b___NwJYs`,
	"secondaryBorderT": `ModuleItem-module__secondary-border-t___l53_5`,
	"secondaryBorderL": `ModuleItem-module__secondary-border-l___yEqmg`,
	"secondaryBorderR": `ModuleItem-module__secondary-border-r___ysxY1`,
	"gap0": `ModuleItem-module__gap-0___btQbq`,
	"gap2": `ModuleItem-module__gap-2___QfYlI`,
	"gap4": `ModuleItem-module__gap-4___X3IKB`,
	"gap5": `ModuleItem-module__gap-5___l6Qvk`,
	"gap6": `ModuleItem-module__gap-6___kH3il`,
	"gap8": `ModuleItem-module__gap-8___BThbw`,
	"gap10": `ModuleItem-module__gap-10___VmnRY`,
	"gap12": `ModuleItem-module__gap-12___SCaCk`,
	"gap14": `ModuleItem-module__gap-14___wkxvQ`,
	"gap16": `ModuleItem-module__gap-16___F4xkG`,
	"gap18": `ModuleItem-module__gap-18___pbNVq`,
	"gap20": `ModuleItem-module__gap-20____6wCp`,
	"gap24": `ModuleItem-module__gap-24___Ja7ET`,
	"gap26": `ModuleItem-module__gap-26___jSgDZ`,
	"gap30": `ModuleItem-module__gap-30___RGWNJ`,
	"gap32": `ModuleItem-module__gap-32___mUmbF`,
	"gap40": `ModuleItem-module__gap-40___ihPA1`,
	"gap50": `ModuleItem-module__gap-50___NY798`,
	"flex1": `ModuleItem-module__flex-1___D0Dpr`,
	"flexNone": `ModuleItem-module__flex-none___J106B`,
	"flexColumn": `ModuleItem-module__flex-column___kMDBW`,
	"flexRow": `ModuleItem-module__flex-row___aLdez`,
	"verticallyCentered": `ModuleItem-module__vertically-centered___CjbXc`,
	"horizontallyCentered": `ModuleItem-module__horizontally-centered___bV3Gq`,
	"horizontallyEnd": `ModuleItem-module__horizontally-end___K3atM`,
	"verticallyStart": `ModuleItem-module__vertically-start___vkIVl`,
	"spaceBetween": `ModuleItem-module__space-between___JOk1k`,
	"flexWrap": `ModuleItem-module__flex-wrap___glaE8`,
	"height100": `ModuleItem-module__height-100___eti2I`,
	"width50": `ModuleItem-module__width-50___xUqYS`,
	"width100": `ModuleItem-module__width-100___L8dDP`,
	"cursorPointer": `ModuleItem-module__cursor-pointer___BbeQa`,
	"cursorNotAllowed": `ModuleItem-module__cursor-not-allowed___BJQnW`,
	"absoluteCentered": `ModuleItem-module__absolute-centered___d0GAR`,
	"absolute": `ModuleItem-module__absolute___V4dJW`,
	"relative": `ModuleItem-module__relative___grn_l`,
	"fixed": `ModuleItem-module__fixed___QPVQY`,
	"visible": `ModuleItem-module__visible___zqGPE`,
	"invisible": `ModuleItem-module__invisible___NOarl`,
	"col90": `ModuleItem-module__col-90___SvAY9`,
	"colAuto": `ModuleItem-module__col-auto___qtV6A`,
	"medicalTabs": `ModuleItem-module__medical-tabs___QK6Xt`,
	"medicalTableNew": `ModuleItem-module__medical-table-new___Txo8F`,
	"noPagination": `ModuleItem-module__no-pagination___uGSw1`,
	"medicalTableEmpty": `ModuleItem-module__medical-table-empty___MGXCS`,
	"iconBtn": `ModuleItem-module__icon-btn___ijeDN`,
	"searchIcon": `ModuleItem-module__search-icon___ZFM8j`,
	"disableSelect": `ModuleItem-module__disable-select___Jv3Nq`,
	"breakWord": `ModuleItem-module__break-word___R45EX`,
	"popupClearBtn": `ModuleItem-module__popup-clear-btn___GHIvo`,
	"scrollMB20": `ModuleItem-module__scroll-m-b-20___CBvER`,
	"checkboxWrapper": `ModuleItem-module__checkboxWrapper___zElj6`,
	"selected": `ModuleItem-module__selected___AdZsM`,
	"instructions": `ModuleItem-module__instructions___g_bFp`
};
module.exports = ___CSS_LOADER_EXPORT___;
